import { PatchUserBody, userApis } from '@apis/userApis';
import { useMutation } from '@hooks/useMutation';
import { useQueryClient } from '@tanstack/react-query';
import { EmailDuplicateError, FormError } from '@utils/errors';

export const usePatchUser = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async (body: PatchUserBody) => {
      const response = await userApis.patch('/user/', { body });
      if (response[400]) {
        if (response[400].email) {
          throw new EmailDuplicateError('This email are already in use');
        }
        throw new FormError('PatchUserError', response[400]);
      }
      if (response[409]) {
        throw new EmailDuplicateError(
          `${response[409]?.email_duplicate_error?.join(',')} are already in use`,
        );
      }
      return response[200]!;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['/company/']);
        queryClient.invalidateQueries(['/user/']);
        queryClient.invalidateQueries(['/company/staff/']);
      },
    },
  );
};
